/**
 * API service for vocabulary data
 * Provides vocabulary operations using local data
 */
import { getRandomWord } from '../data/vocabulary';
import type { VocabularyEntry } from '../types';

/**
 * Get a random vocabulary word
 * Returns immediately from local data
 */
export function fetchRandomWord(): VocabularyEntry | null {
  return getRandomWord();
}
